import { createAction, props } from '@ngrx/store';

import { Calculation, FormValues } from '../models/feed-profit.model';

export const loadData = createAction('[FeedProfit] Load Data');
export const clearFeedProfitState = createAction('[FeedProfit] Clear FeedProfit State');

export const loadCalculationsRequest = createAction('[FeedProfit] Load Calculations Request');
export const loadCalculationsSuccess = createAction(
  '[FeedProfit] Load Calculations Success',
  props<{ calculations: Calculation[] }>(),
);
export const loadCalculationsError = createAction(
  '[FeedProfit] Load Calculations Error',
  props<{ error: Error }>(),
);

export const navigationCalculationDetail = createAction(
  '[FeedProfit] Navigate to calculation detail',
  props<{ calculationId: number }>(),
);
export const setNavigateCalculationSuccess = createAction(
  '[FeedProfit] Set navigate calculation success',
  props<{ calculationId: number }>(),
);

export const setSelectedCalculationSuccess = createAction(
  '[FeedProfit] Set selected calculation success',
  props<{ calculation: Calculation }>(),
);

export const deleteCalculationRequest = createAction(
  '[FeedProfit] Delete calculation request',
  props<{ calculationId: number }>(),
);
export const deleteCalculationWithConfirmation = createAction(
  '[FeedProfit] Confirm Delete calculation',
  props<{ calculationId: number }>(),
);
export const deleteCalculationSuccess = createAction(
  '[FeedProfit] Delete calculation success',
  props<{ calculationId: number }>(),
);
export const deleteCalculationError = createAction(
  '[FeedProfit] Delete calculation error',
  props<{ error: Error }>(),
);
export const updateSelectedCalculation = createAction(
  '[FeedProfit] Update selected calculation',
  props<{ values: FormValues }>(),
);

export const upsertCalculationRequest = createAction(
  '[FeedProfit] Upsert Calculation request',
  props<{ calculation: Calculation }>(),
);
export const upsertCalculationSuccess = createAction(
  '[FeedProfit] Upsert Calculation success',
  props<{ calculation: Calculation }>(),
);
export const upsertCalculationError = createAction(
  '[FeedProfit] Upsert Calculation error',
  props<{ error: Error }>(),
);

export const setIsChanged = createAction(
  '[FeedProfit] Set isChanged property',
  props<{ isChanged: boolean }>(),
);
